import { parseBool } from '@/utils/parse-functions';

import {
	SET_PAGE_LOADING,
	SET_HAS_ACTION_RIBBON,
	SET_CURRENT_ERROR,
	SET_APP_CONFIGS
} from './app-module-mutation-types';

export default {
	strict: process.env.NODE_ENV !== 'production',
	name: 'app',
	namespaced: true,
	state: {
		pageLoading: false,
		hasActionRibbon: false,
		currentError: undefined,

		//the default values are being set in the from .env when app builds
		//but in main.js, we call an api on AccessWeb to get these configs
		//and call the action to set them
		VUE_APP_URL: process.env.VUE_APP_URL,
		VUE_APP_API: process.env.VUE_APP_API,
		VUE_APP_AUTH_SERVER: process.env.VUE_APP_AUTH_SERVER,
		VUE_APP_NAME: process.env.VUE_APP_NAME,
		VUE_APP_SIGNALR_CONNECTION: process.env.VUE_APP_SIGNALR_CONNECTION,
		VUE_APP_ACCESSWEB_URL: process.env.VUE_APP_ACCESSWEB_URL,
		VUE_APP_ACCESSWEB_API_URL: process.env.VUE_APP_ACCESSWEB_API_URL,
		VUE_APP_GTM_ID: process.env.VUE_APP_GTM_ID,
		VUE_APP_GTM_AUTH: process.env.VUE_APP_GTM_AUTH,
		VUE_APP_GTM_ENV: process.env.VUE_APP_GTM_ENV,
		VUE_APP_USE_OIDC: process.env.VUE_APP_USE_OIDC,
		VUE_APP_MODE_TOGGLE: process.env.VUE_APP_MODE_TOGGLE,
		VUE_APP_ACCESSWEB_LOGIN_PAGE: process.env.VUE_APP_ACCESSWEB_LOGIN_PAGE,
		VUE_APP_LOGGING_SOURCE_APPLICATION:
			process.env.VUE_APP_LOGGING_SOURCE_APPLICATION,
		VUE_APP_CLIENT_LOGGING_ENABLED:
			process.env.VUE_APP_CLIENT_LOGGING_ENABLED,
		VUE_APP_CLIENT_LOGGING_API: process.env.VUE_APP_CLIENT_LOGGING_API,
		VUE_APP_CLIENT_ENVIRONMENT_REDIRECT_ENABLED:
			process.env.VUE_APP_CLIENT_ENVIRONMENT_REDIRECT_ENABLED,
		VUE_APP_OPEN_AI: process.env.VUE_APP_OPEN_AI,
		VUE_APP_CONSOLE_LOG_EVENT_LEVEL:
			process.env.VUE_APP_CONSOLE_LOG_EVENT_LEVEL,
		VUE_APP_HELP_URL: process.env.VUE_APP_HELP_URL
	},
	mutations: {
		[SET_PAGE_LOADING](state, loading) {
			state.pageLoading = loading;
		},
		[SET_HAS_ACTION_RIBBON](state, hasActionRibbon) {
			state.hasActionRibbon = hasActionRibbon;
		},
		[SET_CURRENT_ERROR](state, currentError) {
			state.currentError = currentError;
		},
		[SET_APP_CONFIGS](state, appConfigs) {
			Object.assign(state, appConfigs);
		}
	},
	actions: {
		setPageLoadingAction({ commit }, loading) {
			commit(SET_PAGE_LOADING, loading);
		},
		setHasActionRibbonAction({ commit }, hasActionRibbon) {
			commit(SET_HAS_ACTION_RIBBON, hasActionRibbon);
		},
		setCurrentErrorAction({ commit }, currentError) {
			commit(SET_CURRENT_ERROR, currentError);
		},
		clearCurrentErrorAction({ commit }) {
			commit(SET_CURRENT_ERROR, undefined);
		},
		setAppConfigsAction({ commit }, appConfigs) {
			commit(SET_APP_CONFIGS, appConfigs);
		},
		testStoreAction() {
			console.log('testStoreAction');
		}
	},
	getters: {
		appPageLoading: state => {
			return state.pageLoading;
		},
		hasActionRibbon: state => state.hasActionRibbon,
		currentError: state => state.currentError,
		VUE_APP_URL: state => state.VUE_APP_URL,
		VUE_APP_API: state => state.VUE_APP_API,
		VUE_APP_AUTH_SERVER: state => state.VUE_APP_AUTH_SERVER,
		VUE_APP_NAME: state => state.VUE_APP_NAME,
		VUE_APP_BASE: state => state.VUE_APP_BASE,
		VUE_APP_SIGNALR_CONNECTION: state => state.VUE_APP_SIGNALR_CONNECTION,
		VUE_APP_ACCESSWEB_URL: state => state.VUE_APP_ACCESSWEB_URL,
		VUE_APP_ACCESSWEB_API_URL: state => state.VUE_APP_ACCESSWEB_API_URL,
		VUE_APP_GTM_ID: state => state.VUE_APP_GTM_ID,
		VUE_APP_GTM_AUTH: state => state.VUE_APP_GTM_AUTH,
		VUE_APP_GTM_ENV: state => state.VUE_APP_GTM_ENV,
		VUE_APP_USE_OIDC: state => state.VUE_APP_USE_OIDC,
		VUE_APP_MODE_TOGGLE: state => state.VUE_APP_MODE_TOGGLE,
		VUE_APP_ACCESSWEB_LOGIN_PAGE: state =>
			state.VUE_APP_ACCESSWEB_LOGIN_PAGE,
		VUE_APP_LOGGING_SOURCE_APPLICATION: state =>
			state.VUE_APP_LOGGING_SOURCE_APPLICATION,
		VUE_APP_CLIENT_LOGGING_ENABLED: state =>
			state.VUE_APP_CLIENT_LOGGING_ENABLED,
		VUE_APP_CLIENT_LOGGING_API: state => state.VUE_APP_CLIENT_LOGGING_API,
		VUE_APP_CLIENT_ENVIRONMENT_REDIRECT_ENABLED: state =>
			parseBool(state.VUE_APP_CLIENT_ENVIRONMENT_REDIRECT_ENABLED, false),
		VUE_APP_OPEN_AI: state => state.VUE_APP_OPEN_AI,
		VUE_APP_CONSOLE_LOG_EVENT_LEVEL: state =>
			state.VUE_APP_CONSOLE_LOG_EVENT_LEVEL,
		VUE_APP_HELP_URL: state => state.VUE_APP_HELP_URL
	}
};
